// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyState_container__oiBh1","content":"EmptyState_content__Z8sOf","richTextContainer":"EmptyState_richTextContainer__UuqBa"};